import type { FC } from 'react';
import { motion } from 'motion/react';
import { ZiggizLoader } from '@ziggiz/ui';
import { Page } from '@/components/page';

/** Long enough that a warm reload never shows it; short enough to reassure on a slow one. */
const SHOW_AFTER_S = 0.2;

/**
 * What a returning user sees while the session is restored or the app's
 * code loads: the mark, not the sign-in page. It fades in only after a beat,
 * so a fast reload goes straight from blank to the app.
 */
export const AuthPending: FC = () => (
  <Page
    title="Preparing your session"
    className="flex min-h-dvh max-w-none items-center justify-center bg-background p-0"
  >
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: SHOW_AFTER_S, duration: 0.2 }}
    >
      <ZiggizLoader label="Preparing your session" />
    </motion.div>
  </Page>
);
